import { createSvgIcon } from "@mui/material";

export const AlignCenterHIcon = createSvgIcon(
  <svg viewBox="0 0 15 9" fill="none">
    <path
      fill="currentColor"
      d="M7.27 0c.37 0 .633.29.633.633v2.953h6.004a.633.633 0 1 1 0 1.266H7.903v2.953a.61.61 0 0 1-.632.633.625.625 0 0 1-.633-.633V4.852H.634a.634.634 0 0 1-.001-1.266h6.005V.633c0-.343.29-.633.633-.633"
    />
  </svg>,
  "AlignCenterHIcon",
);
